import { parseError as e } from "./contact-channels83.js";
function o(t) {
  if (typeof t == "function")
    try {
      const r = t();
      return r instanceof Promise ? o(r) : { data: r };
    } catch (r) {
      return { error: e(r) };
    }
  return t.then((r) => ({ data: r })).catch((r) => ({ error: e(r) }));
}
export {
  o as attempt
};
//# sourceMappingURL=contact-channels54.js.map
